import { Box, Button, TextField } from "@mui/material";
import { useState } from "react";
import { signIn, confirmSignIn, fetchUserAttributes, fetchAuthSession } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState();
  
  const sendLoginNotification = async (userEmail) => {
    try {
      const session = await fetchAuthSession();
      if (!session.tokens?.accessToken) {
        console.warn("No access token available for login notification");
        return;
      }
      const token = session.tokens.accessToken.toString();
      const response = await fetch("https://api.powerlego.com/generic/send/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 32a72062e2e878d53d97c829a09335b8`,
        },
        body: JSON.stringify({
          Type: "Common",
          Client: "Constellation-slack",
          Email: "",
          Content: `${userEmail} just logged in to PTC Dashboard`,
          Subject: "PTC Dashboard User Login Notification",
          VerifyToken: token
        })
      });
      
      if (!response.ok) {
        console.error("Failed to send login notification");
      }
    } catch (error) {
      console.error("Error sending login notification:", error);
    }
  };
  
  const handleAuth = async () => {
    const { username, password } = state;
    if (!username || !password) {
      setError("Please Enter all required fields");
      return;
    }
    try {
      const auth = await signIn({ username: username, password: password });
      if (auth.nextStep.signInStep === "DONE") {
        const userAttributes = await fetchUserAttributes();
        const userEmail = userAttributes.email || username;
        await sendLoginNotification(userEmail);
        
        navigate("/dashboard");
      }
    } catch {
      setError("Invalid Username or Password");
    }
    // const updatedUser = await confirmSignIn({
    //   challengeResponse: "Admin123!",
    // });
    // console.log("Password changed successfully!", updatedUser);
  };
  const [state, setState] = useState({ username: "", password: "" });
  return (
    <Box className="h-[100vh] flex  justify-center">
      <Box className="pt-10 min-w-[400px]">
        <Box className="w-full p-5 flex justify-center">
          <p className="font-bold text-2xl">Login</p>
        </Box>
        <Box className="w-full mt-5 mb-5">
          <TextField
            className="w-full"
            name="username"
            label="Username"
            variant="outlined"
            value={state.username}
            onChange={(e) => setState({ ...state, username: e.target.value })}
          />
        </Box>
        <Box className="w-full mt-5 mb-5x">
          <TextField
            className="w-full"
            name="username"
            type="password"
            label="Password"
            variant="outlined"
            value={state.password}
            onChange={(e) => setState({ ...state, password: e.target.value })}
          />
        </Box>

        <Box className="mt-5 w-full">
          <Button
            className="w-full"
            variant="contained"
            onClick={() => handleAuth()}
          >
            Login
          </Button>
          <Box>
            {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
